"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("./util");

var Direction;

(function (Direction) {
  Direction["asc"] = "asc";
  Direction["desc"] = "desc";
})(Direction = exports.Direction || (exports.Direction = {}));

function shuffle(input, direction) {
  if (direction === void 0) {
    direction = Direction.asc;
  }

  var tuples = Array.isArray(input) ? util_1.fromArray(input) : util_1.fromObject(input);
  tuples.sort(direction === Direction.desc ? function (a, b) {
    return b[1] - a[1];
  } : function (a, b) {
    return a[1] - b[1];
  });
  return tuples;
}

exports.default = shuffle;
exports.shuffle = shuffle;